import Axios from "axios";
import { adminApi } from "../config";

const endpoint = "/categories";

export const listAllCategories = async (params: any) => {
  try {
    let url = `${endpoint}`;
    const result = await adminApi.get(url, {
      params,
    });
    return result;
  } catch (err) {
    console.log(err, "err");
    if (Axios.isAxiosError(err)) {
      return err.response;
    } else {
      return null;
    }
  }
};

export const listCategoriesForForms = async () => {
  try {
    let url = `${endpoint}/for-forms`;
    const result = await adminApi.get(url);
    return result;
  } catch (err) {
    console.log(err, "err");
    if (Axios.isAxiosError(err)) {
      return err.response;
    } else {
      return null;
    }
  }
};

export const listCategoriesForFormsWithSubcategories = async () => {
  try {
    let url = `${endpoint}/for-forms/with-subcategories`;
    const result = await adminApi.get(url);
    return result;
  } catch (err) {
    console.log(err, "err");
    if (Axios.isAxiosError(err)) {
      return err.response;
    } else {
      return null;
    }
  }
};

export const getCategoryById = async (id: string) => {
  try {
    let url = `${endpoint}/${id}`;
    const result = await adminApi.get(url);
    return result;
  } catch (err) {
    console.log(err, "err");
    if (Axios.isAxiosError(err)) {
      return err.response;
    } else {
      return null;
    }
  }
};

export const createCategory = async (data: any) => {
  try {
    let url = `${endpoint}`;
    const result = await adminApi.post(url, data);
    return result;
  } catch (err) {
    console.log(err, "err");
    if (Axios.isAxiosError(err)) {
      return err.response;
    } else {
      return null;
    }
  }
};

export const updateCategory = async (projectId: string, projectData: any) => {
  try {
    let url = `${endpoint}/${projectId}`;
    const result = await adminApi.put(url, projectData);
    return result;
  } catch (err) {
    console.log(err, "err");
    if (Axios.isAxiosError(err)) {
      return err.response;
    } else {
      return null;
    }
  }
};

export const deleteCategory = async (templateId: string) => {
  try {
    let url = `${endpoint}/${templateId}`;
    const result = await adminApi.delete(url);
    return result;
  } catch (err) {
    console.log(err, "err");
    if (Axios.isAxiosError(err)) {
      return err.response;
    } else {
      return null;
    }
  }
};
